import {StudiosService} from './../../../../services/studios';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {Component} from '@angular/core';
import {NavParams, NavController, Platform} from 'ionic-angular';
import {FindClassPage} from './../../find-class/find-class';
import {ClassesService} from '../../../../services/classes';
import {MapService} from '../../../../services/map';
import {FiltersService} from '../../../../services/filters';
import {LocationsService} from '../../../../services/locations';
import {BackendModule} from '../../../../modules/backend.module';
import {SessionService} from '../../../../services/session';

// pwa/app difference: App uses Ionic native launch navigator

@Component({
  selector: 'page-studio',
  templateUrl: 'studio.html'
})
export class StudioPage {

  studioInfo: any;
  location: any = {};
  userRequestedMap = false;

  constructor(private navCtrl: NavController,
              private navParams: NavParams,
              private classesService: ClassesService,
              public studiosService: StudiosService,
              public filtersService: FiltersService,
              public platform: Platform,
              public iab: InAppBrowser,
              public mapService: MapService,
              public sessionService: SessionService,
              public locationsService: LocationsService,
              public backendModule: BackendModule,
  ) {
    this.studioInfo = navParams.get('studioInfo')
    this.location = {
      lat: Number(this.studioInfo.latitude),
      lng: Number(this.studioInfo.longitude)
    }
  }

  ionViewDidLoad() {
    if (!this.studioInfo.notes) {
      this.studioInfo = this.getStudioInfo(this.studioInfo.id);
    }
  }

  getStudioInfo(studioId) {
    const studio = this.studiosService.studios.find(function (element) {
      return element.id === studioId;
    })

    if (studio) {
      return studio;
    } else {
      return this.studioInfo;
    }
  }

  goToSchedule() {
    this.mapService.searchText = this.studioInfo.name;
    this.mapService.lastSelectedMarker = this.studioInfo;
    this.classesService.initiateClasses()
    this.classesService.loadAll(
      true, // firstload
      null, // fromTime
      null, // toTime
      this.location.lat, // lat
      this.location.lng, // lng
      '1', // radius
      null, // services
      null, // gym (since V1 we don't use this in favor of lat lng with radius 1)
      this.filtersService.queryParams.city, // city
      null, // zones
      null // categories
    )
    this.filtersService.queryParams.latitude = this.location.lat;
    this.filtersService.queryParams.longitude = this.location.lng;
    this.filtersService.queryParams.radius = '1';
    this.filtersService.queryParams.city = null;
    this.filtersService.queryParams.services = [];
    this.filtersService.queryParams.zones = [];
    this.filtersService.queryParams.categories = [];
    this.navCtrl.setRoot(FindClassPage,)
  }

  goToLocation() {
    // should open in google maps
  }

  favorite(studioId) {
    const i = this.sessionService.user.favorite_gyms.indexOf(studioId)
    if (i === -1) {
      this.sessionService.user.favorite_gyms.push(studioId);
    } else {
      this.sessionService.user.favorite_gyms.splice(i, 1)
    }
    console.log(i, this.sessionService.user.favorite_gyms)
    this.backendModule.putAPI(
      `users/${this.sessionService.user.id}`,
      {user: {favorite_gyms: this.sessionService.user.favorite_gyms}}
    ).subscribe(
      (success) => {
        console.log('Saved', success)
      },
      (err) => {
        this.sessionService.reportError('StudiosPage', 'favorite()', err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/studio/studio.ts